import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { noop } from 'lodash';
import cn from 'classnames';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';

import { ExternalLink, Icon } from '@app/components';
import { isAbsoluteURL } from '@app/utils';
import { ShapeWithClassName, VoidFn } from '@app/constants';

interface LinkMenuItemProps {
  to: string;
  icon?: IconDefinition;
  activeClassName?: string;
  onClick?: VoidFn;
}

export const LinkMenuItem: FC<ShapeWithClassName<LinkMenuItemProps>> = ({
  to,
  children,
  icon,
  className,
  activeClassName = 'isActive',
  onClick = noop,
}) => {
  const isExternalLink = isAbsoluteURL(to);

  return (
    <li>
      {isExternalLink ? (
        <ExternalLink href={to} onClick={onClick}>
          {children}
        </ExternalLink>
      ) : (
        <NavLink
          className={({ isActive }) =>
            cn(className, { [activeClassName]: isActive })
          }
          to={to}
          onClick={onClick}
        >
          {icon ? <Icon icon={icon}>{children}</Icon> : children}
        </NavLink>
      )}
    </li>
  );
};
